import React, { Component } from "react";
import PropTypes from 'prop-types';
import browserHistory from '../../Router/RouterHistory';

class Link extends Component {
  static propTypes = {
    className: PropTypes.any,
    children: PropTypes.any.isRequired,
    to: PropTypes.string.isRequired
  };

  handleClick = (event) => {
    browserHistory.push(this.props.to);
    event.preventDefault();
    event.stopPropagation();
  }

  render() {
    return (
      <a {...this.props} onClick={this.handleClick} href={this.props.to}>
        {this.props.children}
      </a>
    );
  }
}

// enable a link as react router link :)
// <div {...LinkTo(ref, '/')}>TOTO link</div>
function LinkTo(to, hrefOverride) {
  const routerPath = to;
  const onRef = (ref) => {
    if (ref && ref.className.indexOf('routerlink') === -1) {
      ref.className = [ ...(ref.className.split(' ').filter(e => e.length)), 'routerlink'].join(' ');
    }
  };
  const onClick = (event) => {
    // allow other event to be trigger
    browserHistory.push(routerPath);
    event.preventDefault();
    event.stopPropagation();
  };

  let props = {
    ref: (ref) => onRef(ref),
    onClick: onClick,
  };

  if (hrefOverride) {
    props.href = routerPath;
  }

  return props;
}

export default Link;
export { LinkTo };
